import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6r1eum8lfs: FaireBrandEntity = {
  token: "b_6r1eum8lfs",
  type: "brand",
  name: "Wonderfully Made .love",
  avatarUrl:
    "https://cdn.faire.com/fastly/a86704c1564334ffd21680484b191b5cfd9fb141fcd911dc8e8a846e7fe037eb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8918bac6cd89c21fbd14f9ef32c2a48dfba0ae9ed6df4de8c855ac05e6969bca.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a86704c1564334ffd21680484b191b5cfd9fb141fcd911dc8e8a846e7fe037eb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8918bac6cd89c21fbd14f9ef32c2a48dfba0ae9ed6df4de8c855ac05e6969bca.png",
  location: "HARTSVILLE, TN, USA",
  minimumOrderDollars: 104,
  rating: 4.8,
  reviewCount: 84,
  isTopShop: true,
  isInsider: true,
  description:
    '"Wonderfully Made" began in 2011 when I realized no one else was looking after the best interest of my children (all 4 of them!), other than me.  I started researching & became "informed, not just opinionated" on what I put in AND ON my body! From there I have taken several classes, obtained degrees, and studied deeply the art of natural Bath and Body Care. I take pride in the quality and effectiveness of each product that is made here, and hope it brings you joy! \n\nWe use only the BEST quality ingredients, all-natural plant-based, with NO NASTY STUFF! Rest assured knowing you are putting SAFE, clean, natural products on you & your family! \n\nEvery item is handmade in small batches with LOVE and INTENTION, right on our farm in Tennessee.  \n\n"We are wonderfully and fearfully made" - Psalms 139:14',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:58.889Z",
    importedBy: "entity-db-cli",
  },
};
